import React, { useState, useEffect } from "react";
import axios from "axios";
import { KAKAO_LOGIN_APP_KEY } from "@src/utils/index";
import { isExternalUrl } from "@src/utils";
import markerImg from "@assets/images/icon/map/ic-map-marker@3x.png";
import icKakaoMap from "@assets/images/icon/map/ic-kakaomap@3x.png";
import icNaverMap from "@assets/images/icon/map/ic-navermap@3x.png";
import icTmap from "@assets/images/icon/map/ic-tmap@3x.png";
import BottomFixedModal from "../bottomFixedModal/BottomFixedModal";

interface Props {
  target: string; // 검색 키워드
  markerSrc?: string; // 마커 이미지 경로
  btnStyle?: object; // 버튼 inline css object
  mapStyle?: object; // 지도 영역 inline css object
  useBottomSheet?: boolean; // 길찾기 바텀시트 사용 여부
  showMap?: boolean; // 지도 표시 여부
}

const defaultBtnStyle = {
  marginTop: 32,
  backgroundColor: "#fff",
  color: "#191919",
  margin: "12px auto",
};
const defaultMapStyle = { borderRadius: "8px", height: "225px" };

const KakaoMapWithModal = ({
  target,
  markerSrc = markerImg,
  btnStyle = defaultBtnStyle,
  mapStyle = defaultMapStyle,
  useBottomSheet = true,
  showMap = true,
}: Props) => {
  const [location, setLocation] = useState({ name: "", x: null, y: null });
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const initializeMap = (mapData) => {
      if (!(window as any).kakao || !(window as any).kakao.maps) {
        console.error("Kakao Maps API가 로드되지 않았습니다.");
        return;
      }

      const kakao = (window as any).kakao;
      const container = document.getElementById("map");
      const options = {
        center: new kakao.maps.LatLng(parseFloat(mapData.y), parseFloat(mapData.x)),
        level: 3,
      };
      const map = new kakao.maps.Map(container, options);

      const imageSrc = markerSrc;
      const imageSize = new kakao.maps.Size(29, 43.45);
      const markerImage = new kakao.maps.MarkerImage(imageSrc, imageSize);
      const markerPosition = new kakao.maps.LatLng(parseFloat(mapData.y), parseFloat(mapData.x));

      const marker = new kakao.maps.Marker({
        position: markerPosition,
        image: markerImage,
      });
      marker.setMap(map);
    };

    axios
      .get<any>(`https://dapi.kakao.com/v2/local/search/keyword.json?query=${target}`, {
        headers: {
          Authorization: `KakaoAK ${KAKAO_LOGIN_APP_KEY}`,
        },
      })
      .then((res) => {
        const hasResults = !!res.data.documents.length;
        if (hasResults) {
          const mapData = res.data.documents[0];
          setLocation({ name: target, x: mapData.x, y: mapData.y });
          initializeMap(mapData);
        }
      })
      .catch((error) => {
        console.error("Kakao API 요청 실패:", error);
      });
  }, [target]);

  return (
    <div>
      {/* {hasData &&  */}
      <>
        {showMap && <div id="map" style={mapStyle} />}
        {useBottomSheet && (
          <>
            <button
              style={btnStyle}
              className="btn btn-large btn-full btn-outline-gray200"
              onClick={() => setShowModal(true)}
            >
              길찾기
            </button>
            <BottomFixedModal
              isShow={showModal}
              isTransition={true}
              hideModal={() => setShowModal(false)}
              title="웨딩홀 길찾기"
            >
              <ul className="link-to-map-list-wrap">
                <li onClick={() => setShowModal(false)}>
                  <a
                    href={`nmap://route/car?dlat=${location.y}&dlng=${location.x}&dname=${location.name}&appname=realtime`}
                  >
                    <img src={icNaverMap} alt="네이버 지도" width={40} />
                    <span>네이버 지도</span>
                  </a>
                </li>
                <li onClick={() => setShowModal(false)}>
                  <a
                    href={`kakaomap://route?ep=${location.y},${location.x}&epName=${location.name}&by=car`}
                  >
                    <img src={icKakaoMap} alt="카카오맵" width={40} />
                    <span>카카오맵</span>
                  </a>
                </li>
                <li onClick={() => setShowModal(false)}>
                  <a
                    href={`tmap://route?goalname=${location.name}&goalx=${location.x}&goaly=${location.y}`}
                  >
                    <img src={icTmap} alt="티맵" width={40} />
                    <span>TMAP</span>
                  </a>
                </li>
              </ul>
            </BottomFixedModal>
          </>
        )}
      </>
      {/* }  */}
    </div>
  );
};

export default KakaoMapWithModal;
